import { Button, Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconFiles } from "@tabler/icons-react";
import { useCallback } from "react";
import FilesModal from "src/components/shared/_Modals/FilesModal/FilesModal";
import { useFilesModal } from "src/components/shared/_Modals/FilesModal/FilesModal.hooks";
import { useCheckPerm } from "src/hooks";
import { useSelector } from "src/redux/hooks";

import { usePendingFilesContext } from "../PendingFilesContext";

interface Props {
  hamburger?: boolean;
}

const FilesButton = ({ hamburger }: Props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const { setPendingFiles } = usePendingFilesContext();
  const { files } = useSelector(state => state.generatorSlice);
  const checkPerm = useCheckPerm();

  const {
    isNewEntry,
    isUploading,
    showRemoved,
    toggleRemoved,
    _files,
    removedNumber,
    handleUpload,
  } = useFilesModal(files, setPendingFiles);

  const Component = useCallback(
    () =>
      hamburger ? (
        <Menu.Item leftSection={<IconFiles size={20} />} onClick={open}>
          Files
        </Menu.Item>
      ) : (
        <Button variant="outline" leftSection={<IconFiles />} onClick={open}>
          Files
        </Button>
      ),
    [hamburger, open],
  );

  if (!checkPerm("viewfiles")) {
    return <></>;
  }

  return (
    <>
      <Component />
      {opened && (
        <FilesModal
          opened={opened}
          close={close}
          handleUpload={handleUpload}
          toggleRemoved={toggleRemoved}
          isUploading={isUploading}
          showRemoved={showRemoved}
          removedNumber={removedNumber}
          isNewEntry={isNewEntry}
          _files={_files}
        />
      )}
    </>
  );
};

export default FilesButton;
